import { V3Record } from 'data/helpers/V3Record.js'

export const GoalParticipantTrip = V3Record('goalParticipantTrip', {
  trip: null, // {}
  goalParticipantId: null, // int
  isExcluded: null // boolean
})
